export default __webpack_public_path__ + "static/media/p1.c223cb68.jpg";